
<div class="page-layout carded left-sidebar inner-scroll" style="overflow-y: scroll;">
    <fuse-sidebar class="sidebar" name="order-main-sidebar" position="left" lockedOpen="gt-md">
        <gallery-main-sidebar></gallery-main-sidebar>
    </fuse-sidebar>

    <!-- CENTER -->
    <div class="center">
        <table>
            <tr>
                <td>
                    <div class="center">
                        <div class="container" appDnd (fileDropped)="onFileDropped($event)">
                            <input type="file" #fileDropRef id="fileDropRef" multiple (change)="fileBrowseHandler($event.target.files)" />
                            <mat-icon class="nav-link-icon">cloud_upload</mat-icon>
                            <h3>{{'Drag and drop file here'|translate}}</h3>
                            <h3>{{'or'|translate}}</h3>
                            <label for="fileDropRef">{{'Browse for file'|translate}}</label>
                        </div>
                    </div>
                </td>
            </tr>
            <tr>
                <td>
                    <div fxLayout="row" class="files-list">
                        <div class="single-file" *ngFor="let file of files; let i = index">
                            <!--        <img src="assets/img/dnd/ic-file.svg" width="45px" alt="file">-->
                            <div class="info">
                                <h4 class="name">
                                    {{ file?.name }}
                                </h4>
                                <p class="size">
                                    {{ formatBytes(file?.size) }}
                                </p>
                                <app-progress [progress]="file?.progress"></app-progress>
                            </div>
                            <!--        <img src="assets/img/dnd/ic-delete-file.svg" class="delete" width="20px" alt="file" (click)="deleteFile(i)">-->
                        </div>
                    </div>
                </td>
            </tr>
            <tr>
                <td>
                    <div class="cards" fxLayout="row wrap">
                        <div class="card" *ngFor="let image of this.gallery.items" fxFlex="20">
                            <div class="card-preview" fxFlex="100">
                                <div class="fuse-card" fxFlex="100">
                                    <img src="data:image/png;base64,{{image.image}}" (click)="showGalleryItemDialog(image)"/><br/>
                                    <a (click)="showDeleteGalleryItemDialog(image)" style="color: red;">{{'Delete'|translate}}</a>
                                    &nbsp;&nbsp;&nbsp;
                                    <a (click)="showGalleryItemDialog(image)" style="color: blue;">{{'Edit'|translate}}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
        </table>
    </div>
</div>
